import React from 'react';
import { Collapse, Checkbox, Divider } from 'antd';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Icon from '@mui/material/Icon';
import { format, parseISO } from 'date-fns';
import { specialColors } from '../../../_config/special_colors';

const { Panel } = Collapse;

const WeavingBoxList = (props) => {
  const build_check_process = (order) => {
    return (
      <Checkbox
        style={{ marginRight: '15px' }}
        checked={order ? (order.checked === 1 ? true : false) : false}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onChange={() => {
          props.updateDataOrdersChecked(order);
        }}
      ></Checkbox>
    );
  };

  const genExtra = (order) => {
    return (
      <div>

        <IconButton
          style={{ marginRight: '10px' }}
          color='primary'
          aria-label='pdf'
          onClick={(e) => {
            e.stopPropagation();
            props.displayPDF(order);
          }}
        >
          <PictureAsPdfIcon />
        </IconButton>
        {build_check_process(order)}
      </div>
    );
  };

  const buildPanel = (d, key, filterFunc) => {
    return (
      <Panel
        style={{ backgroundColor: '#DFFFD9', fontWeight: 'normal' }}
        key={key + 1}
        extra={genExtra(d)}
        header={
          <>

            <strong style={{ marginRight: '20px', fontSize: '0.7em' }}>{`Orden: ${d.id}`}</strong>
            <strong style={{ fontSize: '0.7em' }}>{`Cliente: ${d.ordersDetail.length > 0
              ? d.ordersDetail[0].productPrice
                ? d.ordersDetail[0].productPrice.client
                  ? d.ordersDetail[0].productPrice.client.name
                  : ''
                : ''
              : ''
              }`}</strong>
            <Chip style={{ marginLeft: '20px', fontSize: '0.7em' }} label={`Pedido: ${d.date_created ? format(parseISO(d.date_created), 'dd-MM-yyyy HH:mm:ss') : 'Sin Fecha'}`} size='small' color="primary" variant="outlined" />
            <Chip
              style={{ marginLeft: '20px', fontSize: '0.7em' }}
              label={`Entrega: ${d.date_delivery ? format(parseISO(d.date_delivery), 'dd-MM-yyyy HH:mm:ss') : 'INMEDIATA'
                }`}
              size='small'
              color='warning'
              variant='outlined'
            />
          </>
        }
      >
        <Grid container spacing={1}>
          <Grid container spacing={1}>
            <Grid item xs={8.5} md={8.5}>
              <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                Dirección de envío: {d.address_delivery}
              </span>
            </Grid>
            <Grid item xs={2} md={2}>
              <div style={{ fontSize: '9px' }}>
                <select
                  key={d.uuid}
                  style={{ fontSize: '13px', padding: '-1px' }}
                  data-uuid={d.uuid}
                >
                  {props.process.map((obj) =>
                    obj.name ? (
                      <option
                        key={`${obj.cod}`}
                        value={`${obj.cod}`}
                      >
                        {obj.name}
                      </option>
                    ) : null
                  )}
                </select>
              </div>
            </Grid>
          </Grid>
          <Divider style={{ marginTop: '-1px', marginBottom: '-10px' }} />
          <Grid container spacing={1}>
            <Grid item xs={1.5} md={1.5}>
              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                Producto
              </span>
            </Grid>
            <Grid item xs={1} md={1}>
              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                Color
              </span>
            </Grid>
            <Grid item xs={1} md={1}>
              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                KG
              </span>
            </Grid>
            <Grid item xs={1} md={1}>
              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                MTS
              </span>
            </Grid>
            <Grid item xs={2} md={2}>
              <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                Proceso Asignado
              </span>
            </Grid>
          </Grid>
          {d.ordersDetail.filter(filterFunc).map((od, key) => {

            return (
              <Grid key={key + 'itemOd'} container spacing={1}>
                <Grid item xs={1} md={1.5}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {od.productPrice ? (od.productPrice.product ? od.productPrice.product.ref : '') : ''}
                  </span>
                </Grid>
                <Grid item xs={1} md={1}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {od.color ? od.color.cod : ''}
                  </span>
                </Grid>
                {od.type_quantity === 'KG' ?
                  <Grid item xs={1} md={1}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: 'blue' }}>
                      {od.quantity ? Number(od.quantity).toFixed(4) : ''}
                    </span>
                  </Grid>

                  :
                  <Grid item xs={1} md={1}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                      {od.productPrice.product.productWeight.length > 0 ?
                        (Math.round(od.quantity * od.productPrice.product.productWeight[0].kilo) / od.productPrice.product.productWeight[0].meter).toFixed(2)
                        :
                        'N.A'
                      }
                    </span>
                  </Grid>

                }

                {od.type_quantity === 'MTS' ?

                  <Grid item xs={1} md={1}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: 'blue' }}>
                      {od.quantity ? od.quantity : ''}
                    </span>
                  </Grid>

                  :
                  <Grid item xs={1} md={1}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                      {od.productPrice.product.productWeight.length > 0 ?
                        (Math.round(od.quantity * od.productPrice.product.productWeight[0].meter) / od.productPrice.product.productWeight[0].kilo).toFixed(2)
                        :
                        'N.A'
                      }
                    </span>
                  </Grid>


                }
                <Grid item xs={2} md={2}>
                  <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                    {od.cod_process ? od.cod_process : ''}
                  </span>
                </Grid>
                <Grid item xs={2} md={2}>

                  <IconButton onClick={() => { props.viewQR(od, d.uuid); }}>
                    <Icon>qr_code</Icon>
                  </IconButton>

                </Grid>
                <Grid item xs={2} md={2}>

                  <select
                    key={od.uuid}
                    style={{ fontSize: '13px', padding: '2px' }}
                    data-uuid={od.uuid}
                  >
                    {
                      props.process.map((obj) =>

                        <option
                          key={`${obj.cod}//${d.uuid}//${od.uuid}//${od.color.cod}`}
                          value={`${obj.cod}//${d.uuid}//${od.uuid}//${od.color.cod}`}
                        >
                          {obj.name}
                        </option>


                      )
                    }
                  </select>

                </Grid>


                <Grid>

                </Grid>
              </Grid>
            );


          })}



          <Divider style={{ marginTop: '20px' }} />
          <Grid item xs={12} md={12}>
            <span style={{ fontSize: '12px', fontWeight: 'normal' }}>NOTA: {d.notes}</span>
          </Grid>
        </Grid>
      </Panel>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <div style={{ margin: '10px 0', fontSize: '1.1em', fontWeight: 'bold' }}>Pedidos generales</div>
        <Collapse defaultActiveKey={'panel1'} expandIconPosition={'right'}>
          {props.data.map((d, key) => {
            if (d?.ordersDetail?.some((od) => !specialColors.includes(od.color.cod)))
              return buildPanel(d, key, (od) => !specialColors.includes(od.color.cod));
            else
              return null;
          })}
        </Collapse>
      </Grid>
      <Grid item xs={12} md={6}>
        <div style={{ margin: '10px 0', fontSize: '1.1em', fontWeight: 'bold' }}>Pedidos blancos y negros</div>
        <Collapse defaultActiveKey={'panel2'} expandIconPosition={'right'}>
          {props.data.map((d, key) => {
            if (d?.ordersDetail?.some((od) => specialColors.includes(od.color.cod))) {
              return buildPanel(d, key, (od) => specialColors.includes(od.color.cod));
            } else {
              return null;
            }
          })}
        </Collapse>
      </Grid>
    </Grid>
  );

};

export default WeavingBoxList;
